<script>
import { SancareModal, SancarePasswordInput } from '@sancare/typescript-commons'
import { mapState } from 'vuex'

export default {
  components: {
    'sancare-modal': SancareModal,
    'sancare-password-input': SancarePasswordInput,
  },
  emits: ['change'],
  data() {
    return {
      openModal: true,
      password: '',
    }
  },
  computed: mapState({
    authRequestError: (state) => state.login.authRequest.error,
    username: (state) => state.login.username,
    expiredPassword: (state) => Boolean(state.login.expiredPassword),
    createdFromOidc: (state) => Boolean(state.login.currentUser.createdFromOidc),
  }),
  watch: {
    expiredPassword(expiredPassword) {
      if (!expiredPassword) {
        return
      }

      // Direct use of router is not working
      /* const newRoute = {
        path: `/login/expired-password`,
        query: {username: this.username},
      };
      this.$router.push(newRoute);*/
      this.$store.commit('expiredData', { username: this.username })
      this.cancel()
    },
    value(newValue) {
      this.$emit('change', newValue)
    },
  },
  methods: {
    submitLogin() {
      this.$store.dispatch('authenticate', { username: this.username, password: this.password })
    },
    handleSsoLogin() {
      const url = new URL('/api/oidc/login', window.location.origin)
      url.searchParams.set('redirect', this.$route.fullPath)
      window.location.href = url.toString()
    },
    cancel() {
      this.$store.dispatch('logout')
    },
  }
}
</script>

<template>
  <sancare-modal
    :open="openModal"
    :small="true"
  >
    <template #header>
      <div>
        Session expirée
      </div>
    </template>
    <form @submit.prevent="submitLogin">
      <p class="text-center">
        Voulez-vous continuer ?
      </p>
      <div class="mb-3">
        <sancare-password-input
          v-model="password"
          name="password"
          placeholder="Password"
        />
      </div>
      <div class="mb-3">
        <button
          type="submit"
          class="btn btn-push btn-primary btn-padded btn-fluid"
        >
          Valider
        </button>
      </div>
      <p
        v-if="authRequestError"
        class="text-danger text-center"
      >
        {{ authRequestError }}
      </p>
      <div
        v-if="createdFromOidc"
        class="my-4"
      >
        <div class="d-flex gap-3 align-items-center mb-4">
          <hr class="border-top border-dark flex-grow-1">
          <span>ou connectez-vous avec</span>
          <hr class="border-top border-dark flex-grow-1">
        </div>
        <div class="d-grid">
          <button
            type="button"
            name="sso-login"
            class="btn btn-push btn-secondary btn-padded shadow-sm"
            @click="handleSsoLogin"
          >
            <!-- Authentik logo -->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="30"
              width="30"
              viewBox="0 0 800 700"
              aria-hidden="true"
            >
              <path
                d="M594.05,38.06h-289.87c-63.46,0-115.37,51.92-115.37,115.37v289.87c0,63.46,51.92,115.37,115.37,115.37h34.2v-112.93h221.49v112.93h34.18c63.46,0,115.37-51.92,115.37-115.37V153.43c0-63.46-51.92-115.37-115.37-115.37ZM543.82,354H188.99v-78.04h183.33v-108.36h29.77v64.55h17.45v-64.55h21.05v47.47h17.45v-47.47h21.05v79.3h17.45v-79.3h29.77v108.36h17.51v78.04Z"
                fill="#fd4b2d"
              />
              <path
                d="M190.32,271.3h-.01c-17.27-23.36-43.16-47.14-71.85-47.14-32.99.02-63.31,18.12-79,47.14-32.77,57.15,12.53,134.23,79,132.48,51.43,0,93.85-76.31,93.85-89.8,0-5.97-8.3-24.19-21.98-42.68ZM81.24,271.3c18.51-15.97,45.39-20.63,64.82,0h.01c14.66,13.3,27.46,32.66,32.09,42.5-57.66,120.57-158.73,17.81-96.93-42.5Z"
                fill="#fd4b2d"
              />
            </svg>
            <span class="ms-1">Continuer avec Authentik</span>
          </button>
        </div>
      </div>
      <div class="text-center">
        <button
          type="button"
          class="btn btn-link"
          @click="cancel"
        >
          Retour au login
        </button>
      </div>
    </form>
  </sancare-modal>
</template>
